export default __webpack_public_path__ + "static/media/Amazon.d8e7b1ae.webp";